import Enum from "../../../enums/Enum";

const ExerciseTypeEnum = new Enum({
    RECREATIONAL: {name: "Recreational", nameInArabic: "ممارس لأنشطة ترفيهية/ ترويحية"},
    CLASSES: {name: "Classes", nameInArabic: "فصول ومجموعات تدريبية"},
    PERSONAL_TRAINER: {name: "Personal Trainer", nameInArabic: "مدرب خاص"},
    PERFORMANCE_SPORT: {name: "Performance Sports", nameInArabic: "ممارسة رياضة معينة"},
});

export default ExerciseTypeEnum;